// // src/components/test/ReadingResultsModal.js
// import React from "react";
// import { X, CheckCircle, XCircle, Info } from "lucide-react";

// const ReadingResultsModal = ({
//   showReadingResultsModal,
//   setShowReadingResultsModal,
//   readingFeedback,
//   currentScenario,
//   currentTest,
//   setCurrentStep,
//   questions = [],
// }) => {
//   if (!showReadingResultsModal || !readingFeedback) return null;

//   const summary = readingFeedback.summary || {};
//   const answers = readingFeedback.answers || [];

//   // ✅ Gộp dữ liệu từ answers + questions
//   const mergedResults = answers.map((ans) => {
//     const q = questions.find((q) => q.id === ans.question_id || q.id === ans.id);

//     return {
//       ...ans, // đặt trước
//       question_text: q?.question_text || q?.question || "Question text not available",
//       options: q?.options || [],
//       type: q?.question_type || q?.type || "normal",
//       correct_answer:
//         q?.correct_answer ??
//         q?.answer ??
//         q?.correct ??
//         ans.correct_answer ??
//         ans.correct ??
//         null,
//       explanation: q?.answer_explanation || q?.explanation || q?.rationale || "",
//     };
//   });


//   // ✅ Chuẩn hóa key tránh lỗi ký tự / khoảng trắng
//   const normalizeKey = (key) =>
//     typeof key === "string" ? key.trim().toUpperCase() : String(key || "").trim().toUpperCase();

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg max-w-5xl mx-4 max-h-[90vh] overflow-y-auto shadow-lg">
//         {/* Header */}
//         <div className="p-6 border-b flex items-center justify-between sticky top-0 bg-white z-10">
//           <h3 className="text-xl font-bold text-blue-800">
//             Reading Results - Test {currentTest} Scenario {currentScenario}
//           </h3>
//           <button
//             onClick={() => setShowReadingResultsModal(false)}
//             className="text-gray-400 hover:text-gray-600 transition-colors"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         {/* Summary */}
//         <div className="p-6 bg-blue-50 border-b border-blue-100">
//           <p className="text-blue-800 font-medium">
//             Summary: {summary.correct}/{summary.total_questions} correct answers
//           </p>
//           <p className="text-blue-700 text-sm">
//             Score:{" "}
//             {summary.score_percent?.toFixed
//               ? summary.score_percent.toFixed(1)
//               : summary.score_percent || 0}
//             %
//           </p>
//         </div>

//         {/* Question List */}
//         <div className="p-6 space-y-6">
//           {mergedResults.map((ans, idx) => {
//             const isCorrect = ans.is_correct ?? ans.isCorrect ?? false;
//             // ✅ Chỉ tính selectedKey, correctKey nếu có options
//             let selectedOpt = undefined;
//             let correctOpt = undefined;
//             let selectedKey = "";
//             let correctKey = "";

//             if (Array.isArray(ans.options) && ans.options.length > 0) {
//               selectedKey = normalizeKey(ans.student_choice ?? ans.student_answer ?? ans.selected);
//               correctKey = normalizeKey(ans.correct_answer ?? ans.correct);
//               selectedOpt = ans.options.find(
//                 (opt) => normalizeKey(opt.option_key) === selectedKey
//               );
//               correctOpt = ans.options.find(
//                 (opt) => normalizeKey(opt.option_key) === correctKey
//               );
//             }


//             // 🧩 Debug log để kiểm tra dữ liệu thật từ backend
//             console.log("🧩", {
//               id: ans.question_id,
//               student_choice: ans.student_choice,
//               student_answer: ans.student_answer,
//               selected: ans.selected,
//               answer: ans.answer,
//             });
//             return (
//               <div
//                 key={idx}
//                 className={`border rounded-lg shadow-sm ${isCorrect ? "border-green-200 bg-green-50" : "border-red-200 bg-red-50"
//                   }`}
//               >
//                 {/* Header */}
//                 <div
//                   className={`flex justify-between items-center p-4 border-b ${isCorrect ? "bg-green-100" : "bg-red-100"
//                     }`}
//                 >
//                   <div className="flex items-center space-x-2">
//                     {isCorrect ? (
//                       <CheckCircle className="w-5 h-5 text-green-600" />
//                     ) : (
//                       <XCircle className="w-5 h-5 text-red-600" />
//                     )}
//                     <h4
//                       className={`font-semibold ${isCorrect ? "text-green-700" : "text-red-700"
//                         }`}
//                     >
//                       Question {(ans.question_number || idx + 1)} {isCorrect ? "CORRECT" : "INCORRECT"}
//                     </h4>

//                   </div>
//                 </div>

//                 {/* Body */}
//                 <div className="p-4 space-y-3">
//                   <p className="font-medium text-gray-800 mb-2">{ans.question_text}</p>

//                   {/* ✅ Options hiển thị chuẩn */}
//                   {Array.isArray(ans.options) &&
//                     ans.options.length > 0 &&
//                     ans.type !== "synthesis_matrix" && (
//                       <div className="space-y-1 mb-3">
//                         {ans.options.map((opt, i) => {
//                           const optKey = normalizeKey(opt.option_key);
//                           const isChosen = optKey === selectedKey;
//                           const isCorrectOpt = optKey === correctKey;

//                           let optionClass = "p-2 rounded-md border flex justify-between ";
//                           if (isCorrectOpt && isChosen) {
//                             optionClass += "bg-green-100 border-green-400"; // đúng & chọn
//                           } else if (isCorrectOpt) {
//                             optionClass += "bg-green-50 border-green-300"; // chỉ đúng
//                           } else if (isChosen && !isCorrectOpt) {
//                             optionClass += "bg-red-100 border-red-400"; // chọn sai
//                           } else {
//                             optionClass += "bg-white border-gray-200";
//                           }

//                           return (
//                             <div key={i} className={optionClass}>
//                               <div>
//                                 <span className="font-semibold mr-2">{opt.option_key}.</span>
//                                 <span>{opt.option_text}</span>
//                               </div>

//                               {isCorrectOpt && (
//                                 <div className="text-green-600 font-medium flex items-center">
//                                   <CheckCircle className="w-4 h-4 mr-1" />
//                                   Correct answer
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         })}
//                       </div>
//                     )}
//                   <div className="space-y-3 mb-3">
//                     <div className="flex flex-col md:flex-row gap-3">
//                       {/* Your answer */}
//                       <div
//                         className={`flex-1 p-3 rounded-lg border ${isCorrect
//                           ? "bg-green-50 border-green-200"
//                           : "bg-red-50 border-red-200"
//                           }`}
//                       >
//                         <p className="font-semibold text-gray-700 mb-1">Your answer:</p>

//                         {/* ✅ Khai báo rawAnswer trong JSX để scope chắc chắn có giá trị */}
//                         {(() => {
//                           const rawAnswer =
//                             ans.student_choice ??
//                             ans.student_answer ??
//                             ans.selected ??
//                             ans.answer ??
//                             "";

//                           if (ans.type === "synthesis_matrix") {
//                             const displayValue =
//                               ans.student_choice || ans.student_answer || ans.selected || "(No answer)";
//                             return (
//                               <p className="font-medium text-red-800">
//                                 {displayValue || "(No answer)"}
//                               </p>
//                             );
//                           }


//                           // ✅ Ưu tiên selectedOpt, nếu không thì hiển thị rawAnswer hoặc No answer
//                           if (Array.isArray(ans.options) && ans.options.length > 0) {
//                             if (selectedOpt) {
//                               return (
//                                 <p className={`font-medium ${isCorrect ? "text-green-800" : "text-red-800"}`}>
//                                   {`${selectedOpt.option_key}. ${selectedOpt.option_text}`}
//                                 </p>
//                               );
//                             } else {
//                               return (
//                                 <p className={`font-medium ${isCorrect ? "text-green-800" : "text-red-800"}`}>
//                                   (No answer)
//                                 </p>
//                               );
//                             }
//                           } else {
//                             // ✅ Nếu không có options (vd true_false hoặc fill_in_blank)
//                             if (rawAnswer) {
//                               return (
//                                 <p className={`font-medium ${isCorrect ? "text-green-800" : "text-red-800"}`}>
//                                   {rawAnswer.toString()}
//                                 </p>
//                               );
//                             } else {
//                               return <p className="font-medium text-red-800">(No answer)</p>;
//                             }
//                           }
//                         })()}
//                       </div>

//                       {/* Correct answer */}
//                       <div className="flex-1 p-3 rounded-lg border bg-green-50 border-green-200">
//                         <p className="font-semibold text-gray-700 mb-1">Correct answer:</p>
//                         <p className="font-medium text-green-800">
//                           {correctOpt
//                             ? `${correctOpt.option_key}. ${correctOpt.option_text}`
//                             : correctKey}
//                         </p>
//                       </div>
//                     </div>

//                     <p className="text-sm text-gray-700">
//                       <strong>Score:</strong> {ans.score}
//                     </p>
//                   </div>


//                   {/* ✅ Explanation */}
//                   {ans.explanation && (
//                     <div className="bg-gray-50 border-l-4 border-blue-400 p-3 rounded flex items-start gap-2">
//                       <Info className="text-blue-500 w-5 h-5 mt-0.5" />
//                       <div>
//                         <p className="text-sm text-gray-700">
//                           <strong>Explanation:</strong> {ans.explanation}
//                         </p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Footer */}
//         <div className="p-6 border-t bg-gray-50 flex justify-center">
//           <button
//             onClick={() => {
//               setShowReadingResultsModal(false);
//               setCurrentStep("writing");
//             }}
//             className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
//           >
//             Continue to Writing
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReadingResultsModal;

// src/components/test/ReadingResultsModal.js
import React from "react";
import { X, CheckCircle, XCircle, Info } from "lucide-react";

const ReadingResultsModal = ({
  showReadingResultsModal,
  setShowReadingResultsModal,
  readingFeedback,
  currentScenario,
  currentTest,
  setCurrentStep,
  questions = [],
}) => {
  if (!showReadingResultsModal || !readingFeedback) return null;

  const summary =
    readingFeedback.summary ||
    readingFeedback.data?.summary ||
    readingFeedback.answers_json?.summary ||
    {};
  const answers =
    readingFeedback.answers ||
    readingFeedback.data?.answers ||
    readingFeedback.answers_json?.answers ||
    [];


  console.log("🔍 ReadingResultsModal - Debug:", {
    summary,
    answersCount: answers.length,
    questionsCount: questions.length,
    answers,
    questions
  });

  // Gộp dữ liệu từ answers + questions
  const mergedResults = answers.map((ans) => {
    const q = questions.find((q) => q.id === ans.question_id || q.id === ans.id);

    return {
      ...ans,
      question_text: q?.question_text || q?.question || ans.question_text || "Question text not available",
      options: q?.options || ans.options || [],
      type: q?.question_type || q?.type || ans.type || "normal",
      correct_answer:
        q?.correct_answer ??
        q?.answer ??
        q?.correct ??
        ans.correct_answer ??
        ans.correct ??
        null,
      explanation: q?.answer_explanation || q?.explanation || q?.rationale || ans.explanation || "",
    };
  });

  console.log("📦 Merged Results:", mergedResults);

  // Chuẩn hóa key tránh lỗi ký tự / khoảng trắng
  const normalizeKey = (key) =>
    typeof key === "string" ? key.trim().toUpperCase() : String(key || "").trim().toUpperCase();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col shadow-2xl">
        {/* Header - Fixed */}
        <div className="p-6 border-b flex items-center justify-between bg-white flex-shrink-0">
          <h3 className="text-xl font-bold text-blue-800">
            Reading Results - Test {currentTest} Scenario {currentScenario}
          </h3>
          <button
            onClick={() => setShowReadingResultsModal(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Summary - Fixed */}
        <div className="p-6 bg-blue-50 border-b border-blue-100 flex-shrink-0">
          <p className="text-blue-800 font-medium text-lg">
            Summary: {summary.correct}/{summary.total_questions} correct answers
          </p>
          <p className="text-blue-700">
            Score: {summary.score_percent?.toFixed ? summary.score_percent.toFixed(1) : summary.score_percent || 0}%
          </p>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-6 space-y-6">
            {mergedResults.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No questions to display
              </div>
            ) : (
              mergedResults.map((ans, idx) => {
                const isCorrect = ans.is_correct ?? ans.isCorrect ?? false;

                // Chỉ tính selectedKey, correctKey nếu có options
                let selectedOpt = undefined;
                let correctOpt = undefined;
                let selectedKey = "";
                let correctKey = "";

                if (Array.isArray(ans.options) && ans.options.length > 0) {
                  selectedKey = normalizeKey(ans.student_choice ?? ans.student_answer ?? ans.selected ?? "");
                  correctKey = normalizeKey(ans.correct_answer ?? ans.correct ?? "");
                  selectedOpt = ans.options.find(
                    (opt) => normalizeKey(opt.option_key) === selectedKey
                  );
                  correctOpt = ans.options.find(
                    (opt) => normalizeKey(opt.option_key) === correctKey
                  );
                }

                return (
                  <div
                    key={idx}
                    className={`border-2 rounded-lg shadow-sm overflow-hidden ${isCorrect ? "border-green-300" : "border-red-300"
                      }`}
                  >
                    {/* Question Header */}
                    <div
                      className={`flex justify-between items-center p-4 ${isCorrect ? "bg-green-100" : "bg-red-100"
                        }`}
                    >
                      <div className="flex items-center space-x-2">
                        {isCorrect ? (
                          <CheckCircle className="w-5 h-5 text-green-600" />
                        ) : (
                          <XCircle className="w-5 h-5 text-red-600" />
                        )}
                        <h4
                          className={`font-bold ${isCorrect ? "text-green-700" : "text-red-700"
                            }`}
                        >
                          Question {ans.question_number || idx + 1}
                        </h4>
                      </div>
                      <span
                        className={`font-semibold ${isCorrect ? "text-green-700" : "text-red-700"
                          }`}
                      >
                        {isCorrect ? "CORRECT" : "INCORRECT"}
                      </span>
                    </div>

                    {/* Question Body */}
                    <div className="p-5 bg-white space-y-4">
                      {/* Question Text */}
                      <div>
                        <p className="font-semibold text-gray-700 mb-2">Question:</p>
                        <p className="text-gray-800 leading-relaxed">{ans.question_text}</p>
                      </div>

                      {/* Options - Hiển thị list đơn giản */}
                      {Array.isArray(ans.options) &&
                        ans.options.length > 0 &&
                        ans.type !== "synthesis_matrix" && (
                          <div>
                            <p className="font-semibold text-gray-700 mb-2">Options:</p>
                            <div className="space-y-2 pl-1">
                              {ans.options.map((opt, i) => {
                                const optKey = normalizeKey(opt.option_key);
                                const isCorrectOpt = optKey === correctKey;

                                return (
                                  <div key={i} className="flex items-start gap-2 text-gray-700">
                                    <span className="font-semibold min-w-[24px]">{opt.option_key}.</span>
                                    <span className="flex-1">{opt.option_text}</span>
                                    {isCorrectOpt && (
                                      <span className="text-green-600 text-sm flex items-center whitespace-nowrap ml-2">
                                        <CheckCircle className="w-4 h-4 mr-1" />
                                        Correct answer
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                      {/* Your Answer & Correct Answer - 2 columns */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Your Answer */}
                        <div>
                          <p className="font-semibold text-gray-700 mb-2">Your answer:</p>
                          <div
                            className={`p-3 rounded-md border-2 min-h-[60px] flex items-center ${isCorrect
                                ? "bg-green-50 border-green-300"
                                : "bg-red-50 border-red-300"
                              }`}
                          >
                            {(() => {
                              const rawAnswer =
                                ans.student_choice ??
                                ans.student_answer ??
                                ans.selected ??
                                ans.answer ??
                                "";

                              if (ans.type === "synthesis_matrix") {
                                const displayValue =
                                  ans.student_choice ||
                                  ans.student_answer ||
                                  ans.selected ||
                                  "(No answer)";
                                return (
                                  <p
                                    className={`font-medium ${isCorrect ? "text-green-700" : "text-red-700"
                                      }`}
                                  >
                                    {displayValue}
                                  </p>
                                );
                              }

                              if (Array.isArray(ans.options) && ans.options.length > 0) {
                                if (selectedOpt) {
                                  return (
                                    <p
                                      className={`font-medium ${isCorrect ? "text-green-700" : "text-red-700"
                                        }`}
                                    >
                                      {selectedOpt.option_key}. {selectedOpt.option_text}
                                    </p>
                                  );
                                } else {
                                  return <p className="font-medium text-gray-500">(No answer)</p>;
                                }
                              } else {
                                if (rawAnswer) {
                                  return (
                                    <p
                                      className={`font-medium ${isCorrect ? "text-green-700" : "text-red-700"
                                        }`}
                                    >
                                      {rawAnswer.toString()}
                                    </p>
                                  );
                                } else {
                                  return <p className="font-medium text-gray-500">(No answer)</p>;
                                }
                              }
                            })()}
                          </div>
                        </div>

                        {/* Correct Answer */}
                        <div>
                          <p className="font-semibold text-gray-700 mb-2">Correct answer:</p>
                          <div className="p-3 rounded-md border-2 bg-green-50 border-green-300 min-h-[60px] flex items-center">
                            <p className="font-medium text-green-700">
                              {correctOpt
                                ? `${correctOpt.option_key}. ${correctOpt.option_text}`
                                : correctKey || ans.correct_answer || "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Explanation */}
                      {ans.explanation && (
                        <div className="bg-blue-50 border-l-4 border-blue-500 rounded-r p-4 flex gap-3">
                          <Info className="text-blue-600 w-5 h-5 mt-0.5 flex-shrink-0" />
                          <div className="flex-1">
                            <p className="font-semibold text-blue-900 mb-1">Explanation:</p>
                            <p className="text-sm text-blue-800 leading-relaxed">
                              {ans.explanation}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Footer - Fixed */}
        <div className="p-6 border-t bg-gray-50 flex justify-center flex-shrink-0">
          <button
            onClick={() => {
              setShowReadingResultsModal(false);
              setCurrentStep("writing");
            }}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold shadow-md"
          >
            Continue to Writing
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReadingResultsModal;